"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFairs = void 0;
const types_1 = require("../types");
const createFair = (fair) => {
    const fairTypesChecks = [
        {
            type: types_1.FairType.Black,
            strings: ['black feirao', 'blackfeirao'],
        },
        {
            type: types_1.FairType.Mega,
            strings: ['mega feirao', 'megafeirao'],
        },
    ];
    const getFairType = () => {
        const fairName = fair.Name.toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '');
        let fairType = types_1.FairType.Default;
        fairTypesChecks.forEach(({ type, strings }) => {
            if (strings.some((v) => fairName.includes(v))) {
                fairType = type;
            }
        });
        return fairType;
    };
    return {
        id: fair.Id,
        name: fair.Name,
        slug: fair.URL,
        vehicleType: fair.Modalidade,
        banner: {
            mobile: fair.BannerMobile,
            desktop: fair.BannerDesktop,
        },
        type: getFairType(),
    };
};
const parseFairs = (fairs) => fairs.map(createFair);
exports.parseFairs = parseFairs;
//# sourceMappingURL=index.js.map